var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.38153,
    height: 20.243,
    rx: 1.19077,
    transform: "matrix(0.707018 0.707196 -0.707018 0.707196 18.3125 4)",
    fill: "#EF4040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 13.6758L13.6818 11.9916L19.1579 17.469C19.6228 17.9341 19.6228 18.6881 19.1579 19.1532V19.1532C18.6929 19.6183 17.939 19.6183 17.4741 19.1532L11.998 13.6758Z",
    fill: "#EF4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84189 6.52631C4.37693 6.06123 4.37693 5.30718 4.84189 4.8421V4.8421C5.30686 4.37702 6.06072 4.37702 6.52568 4.8421L12.0065 10.3243L10.3227 12.0085L4.84189 6.52631Z",
    fill: "#EF4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.63b3f9cf9d52e3e1ae0492e79122a0e8.svg";
export { ForwardRef as ReactComponent };